var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showMasterControl)?_c(_setup.MasterApplyControl):(_setup.showMemberControl)?_c(_setup.MemberApplyControl):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }